$(document).ready(function(){$(".megamenu").megamenu();});

addEventListener("load", function() { setTimeout(hideURLbar, 0); }, false); function hideURLbar(){ window.scrollTo(0,1); }

$('#calcularFrete').on('click', function(e) {
    e.preventDefault();
    $('#modalFrete').modal('show');
});